module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/t95e6.f60ee426.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/t95e6.png
// module id = 1031
// module chunks = 16